var Tracker = /** @class */ (function () {
    function Tracker() {
        this.pending = true;
        this.rejected = false;
        this.fulfilled = false;
    }
    Tracker.prototype.isPending = function () { return this.pending; };
    Tracker.prototype.isRejected = function () { return this.rejected; };
    Tracker.prototype.isFulfilled = function () { return this.fulfilled; };
    return Tracker;
}());
export { Tracker };
